import type {StateCreator} from 'zustand'

export interface SuggestionBatchSlice {
  suggestionBatch: {
    activeBatch: number[]
    isSuggestionBatchPending: boolean
  }
  suggestionBatchActions: {
    addSuggestionToBatch: (commentDatabaseId: number) => void
    removeSuggestionFromBatch: (commentDatabaseId: number) => void
    clearSuggestionBatch: () => void
    loadActiveBatchFromStorage: (activeBatch: number[]) => void
  }
}

export type SuggestionBatchSliceOpts = {
  initialActiveBatch?: number[]
}

export const createSuggestionBatchSlice =
  (opts: SuggestionBatchSliceOpts): StateCreator<SuggestionBatchSlice, [], [], SuggestionBatchSlice> =>
  set => ({
    suggestionBatch: {
      activeBatch: opts.initialActiveBatch ?? [],
      isSuggestionBatchPending: (opts.initialActiveBatch?.length ?? 0) > 0,
    },
    suggestionBatchActions: {
      addSuggestionToBatch: (commentDatabaseId: number) =>
        set(state => {
          if (state.suggestionBatch.activeBatch.includes(commentDatabaseId)) {
            return state
          }
          const newActiveBatch = [...state.suggestionBatch.activeBatch, commentDatabaseId]

          return {
            suggestionBatch: {
              ...state.suggestionBatch,
              activeBatch: newActiveBatch,
              isSuggestionBatchPending: newActiveBatch.length > 0,
            },
          }
        }),
      removeSuggestionFromBatch: (commentDatabaseId: number) =>
        set(state => {
          const newActiveBatch = state.suggestionBatch.activeBatch.filter(id => id !== commentDatabaseId)

          return {
            suggestionBatch: {
              ...state.suggestionBatch,
              activeBatch: newActiveBatch,
              isSuggestionBatchPending: newActiveBatch.length > 0,
            },
          }
        }),
      clearSuggestionBatch: () =>
        set(state => {
          return {
            suggestionBatch: {
              ...state.suggestionBatch,
              activeBatch: [],
              isSuggestionBatchPending: false,
            },
          }
        }),
      loadActiveBatchFromStorage: (activeBatch: number[]) =>
        set(state => ({
          suggestionBatch: {
            ...state.suggestionBatch,
            activeBatch,
            isSuggestionBatchPending: activeBatch.length > 0,
          },
        })),
    },
  })
